import { Typography, useTheme } from '@mui/material';
import { TagChip } from 'components/ui';
import { TableContext } from 'pages/PatientsPage';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  determineActivityKey,
  getActivityList,
} from 'pages/PatientsPage/PatientsFilter/Filters/ActivityFilter';

export const ActivityFilterChip = () => {
  const { t } = useTranslation();
  const theme = useTheme()
  const { filters, setFilters } = useContext(TableContext);
  
  const activityList = getActivityList(t);
  const selectedKey = determineActivityKey(filters);

  function deleteFilter() {
    setFilters({
      ...filters,
      lastActivity: undefined,
      noActivity: undefined,
    });
  }

  if (selectedKey === '') return null;

  return (
    <TagChip
      key={selectedKey}
      tag={
        <>
          <Typography
            component="span"
            color={theme.palette.colors.black}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {`${t('Activity')}: `}
          </Typography>
          <Typography
            component="span"
            color={theme.palette.colors.blue100}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {activityList.find((act) => act.key === selectedKey).label}
          </Typography>
        </>
      }
      handleDelete={() => deleteFilter()}
      isCanDelete
      iconColor={theme.palette.colors.blue100}
    />
  );
};
